module.exports = __webpack_public_path__ + "img/chat_popup.f23b7542.svg";